module.exports = __webpack_public_path__ + "img/bg.859fd57a.jpg";